export const roundToNearestHundred = (num) => {
	return Math.ceil(num / 100) * 100;
};

export const roundToNearestTen = (num) => {
	return Math.ceil(num / 10) * 10;
};

export const formatCurrency = (value) => {
	return `₦${ parseFloat(value).toLocaleString() }`
}

export const generatePaymentPlans = ({ price, no_of_months, upfront_amount, credit, quantity }) => {
	let plans = [];
	if (credit) {
		if (no_of_months > 2) {
			if (upfront_amount <= (price / 2)) {
				plans.push({
					monthly_amount: roundToNearestHundred(price / 2),
					no_of_months: 1,
					upfront_amount: price / 2,
					sell_on_credit: 1
				});
			} else {
				plans.push({
					monthly_amount: roundToNearestHundred(price - upfront_amount),
					no_of_months: 1,
					upfront_amount: upfront_amount,
					sell_on_credit: 1
				});
			}
		}
		if (no_of_months > 3) {
			if (no_of_months % 2 === 0) {
				plans.push({
					monthly_amount: roundToNearestHundred((price - upfront_amount) / (no_of_months / 2)),
					no_of_months: no_of_months / 2,
					upfront_amount,
					sell_on_credit: 1
				});
			} else {
				plans.push({
					monthly_amount: roundToNearestHundred((price - upfront_amount) / ((no_of_months - 1) / 2)),
					no_of_months: (no_of_months - 1) / 2,
					upfront_amount,
					sell_on_credit: 1
				});
			}
		}
		plans.push({
			monthly_amount: roundToNearestHundred((price - upfront_amount) / (no_of_months - 1)),
			no_of_months: no_of_months - 1,
			upfront_amount,
			sell_on_credit: 1
		});
	}

	plans = plans.map((plan, i) => {
		const monthly_amount = plan.monthly_amount * quantity;
		const upfront_amount = plan.upfront_amount * quantity;
		const text = plan.sell_on_credit === 1 ?
			`Pay ${ formatCurrency(upfront_amount) } now and ${ formatCurrency(monthly_amount) } in ${ plan.no_of_months } month(s)`
			: `Pay ${ formatCurrency(upfront_amount) } in outright purchase`;
		return { ...plan, value: i, text, monthly_amount, upfront_amount }
	});

	return plans
}

export const nPercentOf = (percent, total) => {
	return +((percent / 100) * total).toFixed(2);
}

export const jsonToBase64 = (obj) => {
	const str = JSON.stringify(obj);
	return btoa(str);
};


export const getRandomIntInclusive = (min, max) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1) + min);
}
